<ng-container *ngIf="header; else row">
    <div class="table action-row-header" id="row-header">
        <div class="row-wrapper">
            <div class="row-title">
                <div>Recommended Product based on similar customer purchases.</div>
                <div>Solution</div>
            </div>

            <div class="locations-header" *ngIf="currPageState!=='Recommended'">
                Previous Recommended Locations
            </div>
            <div class="locations-header">
                Current Recommended Locations
            </div>

            <div class="impact">
                Opportunity (Sales / TVD)
            </div>

            <div class="state-specific-info">
                <div class="doughnut" *ngIf="currPageState==='Recommended'">
                        Difficulty
                </div>

                <div class="status-bar" *ngIf="currPageState==='My Actions'">
                    Current Status
                </div>

                <div class="info-container" *ngIf="currPageState==='Snoozed'">
                    Snooze Date and duration of snooze
                </div>

                <div class="info-container" *ngIf="currPageState==='Dismissed'">
                    Dismissal reason
                </div>

                <div class="info-container" *ngIf="currPageState==='Completed'">
                    Completed Date
                </div>
            </div>

            <div>
                Options
            </div>
        </div>
    </div>
</ng-container>
<ng-template #row>
    <ng-container *ngIf="isMoved; else tableRow">
        <app-alert [id]="1" [message]="displayMovedAlert()" [error]="false">
        </app-alert>
    </ng-container>
    <ng-template #tableRow>
        <div class="table" *ngIf="dataRow != undefined" id="{{dataRow.recId}}">
            <div class="row-wrapper">
                <ng-container *ngIf="displayLoaderFlag">
                    <div class="row-loader">
                        <loader [size]="'small'"></loader>
                    </div>
                </ng-container>

                <div class="row-title">
                    <div class="heading">{{dataRow.productName}}</div>
                    <div class="sub-heading">{{dataRow.solution}}</div>
                </div>
                
                <!-- Previous Locations saved in cosmos -->
                <div class="previous-locations" *ngIf="currPageState!=='Recommended'">
                    <div class="locations-container" (click)="openLocationBox(dataRow.previousLocations)">
                        <div class="locations-count">
                            {{dataRow.previousLocations.length}}
                        </div>

                        <div class="locations-text">
                            Locations
                        </div>
                    </div>
                </div>

                <!-- Current Locations in Snowflake-->
                <div class="current-locations">
                    <div class="locations-container" (click)="openLocationBox(dataRow.currentLocations)">
                        <div class="locations-count">
                            {{dataRow.currentLocations.length}}
                        </div>

                        <div class="locations-text">
                            Locations
                        </div>
                    </div>
                </div>

                <div class="impact">
                    <div class="value">
                        <span *ngIf="isTvdType(opportunityType)">
                            <img src="{{opportunityType | eroi:'grayIcon'}}" alt="opportunityType"
                                class="option-image" />
                        </span>
                        + ${{mapOpportunityTypeToCostValue(opportunityType) | abbreviateNumber}}
                    </div>
                    <div class="unit">
                        {{mapOpportunityTypeToValue(opportunityType)}}
                        {{mapOpportunityTypeToUnits(opportunityType)}}
                    </div>
                </div>

                <div class="state-specific-info">
                    <div class="doughnut" *ngIf="currPageState==='Recommended'">
                        <div class="half-douhgnut-chart-container flex-centered">
                            <div class="halfdoughnut-donut margin"
                                [style.--percentage]="(dataRow.groupedDifficultyScale/5)*100"
                                [style.--fill]="dataRow.groupedDifficultyScale < 2.5 ? '#39B54A' : '#F17A22'">
                                <span>{{ dataRow.groupedDifficultyScale }}</span>
                            </div>
                            <div class="text">out of 5</div>
                        </div>
                    </div>

                    <div class="status-bar" *ngIf="currPageState==='My Actions'">
                        <div class="status-bar-container">
                            <span class="action-text"
                                [ngClass]="statusClass(dataRow.recState.recommendationStatus)">{{dataRow.recState.recommendationStatus}}
                            </span>
                        </div>
                    </div>

                    <div class="info-container" *ngIf="currPageState==='Snoozed'">
                        <div class="status-text">
                            {{dataRow.recState.snoozeDuration}} months
                        </div>
                        <div class="status-text">
                            since {{displayDate(dataRow.recState.snoozeDate)}}
                        </div>
                    </div>

                    <div class="info-container" *ngIf="currPageState==='Dismissed'">
                        <div class="status-text">
                            {{dataRow.recState.dismissReason}}
                        </div>
                    </div>

                    <div class="info-container" *ngIf="currPageState==='Completed'">
                        <div class="status-text">
                            {{displayDate(dataRow.recState.endDate)}}
                        </div>
                    </div>
                </div>

                <app-row-menu [currPageState]="currPageState" [recId]="dataRow.recId" [recName]="dataRow.productName"
                    (displayLoader)="displayRowLoader($event)" (actionMoved)="actionMoved($event)">
                </app-row-menu>
            </div>
        </div>

        <!-- LOCATION POP UP -->
        <div class="locationsContainer" *ngIf="showDialogBox && dataRow!=undefined">
            <div class="locationBox">
                <div class="header">
                    <div class="title">Locations ({{locationPopupData.length}})</div>
                    <div class="headerRightSection">
                        <span class="downloadButton">
                            <button type="button" class="buttonOutline" (click)="exportToExcel(locationPopupData)">
                                <img src="assets/download-icon.svg" alt="download Icon">
                                Download
                            </button>
                        </span>
                        <span class="closeDialogIcon" (click)="closeLocationBox()">
                            <img src="assets/close-icon.svg" alt="close dialog">
                        </span>
                    </div>
                </div>

                <table>
                    <thead>
                        <tr class="tableHeader">
                            <th class="column">Unit Number</th>
                            <th class="column">Name</th>
                            <th class="column">Street</th>
                            <th class="column">City</th>
                            <th class="column">State</th>
                        </tr>
                    </thead>
                    <tbody class="tableBody">
                        <tr class="dataRow" *ngFor="let location of locationPopupData">
                            <td class="dataColumn unit">{{location?.accountNumber}}</td>
                            <td class="dataColumn unit">{{location?.accountName}}</td>
                            <td class="dataColumn">{{location?.street}}</td>
                            <td class="dataColumn">{{location?.city}}</td>
                            <td class="dataColumn">{{location?.state}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </ng-template>
</ng-template>